import type { PreTripInspectionItemResponseDto, PtiFluidLevel } from "../../api/ptiApi";
import { isImageFile } from "../../utils/fileUtils";

export type PtiMeasurementDraft = {
    treadDepth: string;
    brakeMeasurement: string;
    tirePsi: string;
    fluidLevel?: PtiFluidLevel | null;
};

export const hasPtiItemImage = (item: PreTripInspectionItemResponseDto) =>
    Boolean(item.url) && (!item.contentType || isImageFile(item.contentType));

export const getPtiItemKey = (item: PreTripInspectionItemResponseDto) =>
    `${item.assetType}:${item.itemType}:${item.positionKey}`;

export const getPtiApiErrorMessage = (error: any, fallback: string) => {
    const messages = error?.data?.errors;
    if (Array.isArray(messages) && messages.length > 0) {
        return messages.join(" ");
    }

    return error?.data?.message || fallback;
};
